import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import {
  getItineraryForCounter,
  putTicketChangeLocation,
} from '../../../../../actions/index';
import Modal from '../../../../common/modal/Modal';
import ChangeLocationForm from './ChangeLocationForm';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { generateTicketChangeLocation } from '../../../../../config/endpoints';
import { PUT } from '../../../../../config/permissions';

const ChangeLocationButton = ({
  ticket,
  dispatchGetItineraryForCounter,
  dispatchPutTicketChangeLocation,
  forThirdParty,
  disabled
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleTicketRefund = async (formValues) => {
    const newFormValues = {
      newSourceLocationId: formValues.newSourceLocation
        ? formValues.newSourceLocation.value
        : null,
      newDestinationLocationId: formValues.newDestinationLocation
        ? formValues.newDestinationLocation.value
        : null,
    };

    const ticketId = ticket.get('id');

    dispatchPutTicketChangeLocation(ticketId, forThirdParty, newFormValues);
  };

  const handleShowModal = async () => {
    setLoading(true);

    try {
      const itinerary = ticket.get('itinerary');
      const itineraryId = itinerary.id;

      await dispatchGetItineraryForCounter(itineraryId);
      setShowModal(true);
    } catch (e) {
      toastr.error('Error', 'No se pudo cargar el itinerario.');
    }

    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const sourceLocation = ticket.get('sourceLocation');
  const destinationLocation = ticket.get('destinationLocation');

  const initialValues = {
    newSourceLocation: sourceLocation && {
      value: sourceLocation.id,
      label: sourceLocation.name,
    },
    newDestinationLocation: destinationLocation && {
      value: destinationLocation.id,
      label: destinationLocation.name,
    },
  };

  return (
    <>
      <Button color="warning" onClick={handleShowModal} disabled={disabled}>
        <i className={`fa fa-${loading ? 'spinner fa-spin' : 'refresh'}`} />{' '}
        Cambiar Embarque / Desembarque
      </Button>

      <Modal
        show={showModal}
        title="Cambio de Embarque / Desembarque"
        body={
          <ChangeLocationForm
            initialValues={initialValues}
            onSubmit={handleTicketRefund}
            onCancel={handleCloseModal}
          />
        }
        size="md"
      />
    </>
  );
};

ChangeLocationButton.propTypes = {
  dispatchGetItineraryForCounter: PropTypes.func.isRequired,
  dispatchPutTicketChangeLocation: PropTypes.func.isRequired,
  ticket: PropTypes.instanceOf(Immutable.Map).isRequired,
  forThirdParty: PropTypes.bool,
  disabled: PropTypes.bool
};

ChangeLocationButton.defaultProps = {
  forThirdParty: false,
  disabled: false
};

const mapDispatchToProps = {
  dispatchPutTicketChangeLocation: putTicketChangeLocation,
  dispatchGetItineraryForCounter: getItineraryForCounter,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(ChangeLocationButton);

export default withEndpointAuthorization({
  url: generateTicketChangeLocation(0),
  permissionType: PUT,
})(connectedComponent);
